/**
 * EndPointBrowser.js
 *
 * Copyright (c) apploft. GmbH
 */

import React, {useReducer} from 'react';
import {APIDefinition} from 'apploft-cloud-client';
import {ready, reducer} from './EndPointBrowserState';
import EndPoints from './EndPoints';
import Container from './Container';
import './EndPointBrowser.css';

function EndPointBrowser({api, strings, colors}) {
  const initialState = {
    type: ready,
    sections: APIDefinition.sections(api),
    section: APIDefinition.sections(api)[0],
  };

  const [store, dispatch] = useReducer(reducer, initialState);
  const {
    info: {title},
  } = api;

  return (
    <div className="endpointBrowser">
      <div className="endpointBrowserMenu">
        <div className="logo" />
        <EndPoints
          title={title}
          sections={store.sections}
          dispatch={dispatch}
          section={store.section}
          strings={strings}
          colors={colors}
        />
      </div>

      <Container section={store.section} api={api} strings={strings} />
    </div>
  );
}

export default EndPointBrowser;
